export default __webpack_public_path__ + "static/media/maintenance.44a85d51.svg";